import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    headerShow:true,
    footerShow:true,
    registerShow:false,
    loginShow:false,
    logining:false,
    passwordReset:false,
    afterLoginUrl:"",
  },
  getters: {
  },
  mutations: {
    headerChange(state,flag){
      state.headerShow = flag;
    },
    footerChange(state,flag){
      state.footerShow = flag;
    },
    registerToggle(state,flag){
      state.registerShow = flag;
    },
    loginToggle(state,flag){
      state.loginShow = flag;
    },
    loginIngToggle(state,flag){
      state.logining = flag;
    },
    passwordResetToggle(state,flag){
      state.passwordReset = flag;
    },
    afterLoginUrlChange(state,flag){
      state.afterLoginUrl = flag;
    },
  },
  actions: {
  },
  modules: {
  }
})
